<template>
  <div
    class="split-view-buttons"
    :class="{
      'split-view-buttons--active': splitIndoorViewer
    }"
  >
    <SyncViewButton
      v-if="splitIndoorViewer"
      :imgSource="iconSplitSync"
      @clicked="$emit('syncButtonClick', 1)"
    />
    <SplitViewButton :active="splitIndoorViewer" @clicked="onSplitViewButtonClick" />
    <SyncViewButton
      v-if="splitIndoorViewer"
      :imgSource="iconSplitSyncReverse"
      @clicked="$emit('syncButtonClick', 2)"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { SplitViewButton, SyncViewButton } from './index'
import { SET_SPLIT_INDOORVIEWER } from '@/store/mutation-types'
import { INDOORVIEWER_PREFIX } from '@/store/module-prefixes'
import iconSplitSync from '@/assets/icon-indoorview-split-sync.svg'
import iconSplitSyncReverse from '@/assets/icon-indoorview-split-sync-reverse.svg'

export default {
  name: 'SplitViewButtons',
  components: {
    SplitViewButton,
    SyncViewButton
  },
  props: {
    splitIndoorViewer: {
      type: Boolean,
      default: false
    }
  },
  emits: ['syncButtonClick'],
  data() {
    return {
      iconSplitSync,
      iconSplitSyncReverse
    }
  },
  methods: {
    ...mapMutations(INDOORVIEWER_PREFIX, {
      setSplitIndoorviewer: SET_SPLIT_INDOORVIEWER
    }),
    onSplitViewButtonClick() {
      this.setSplitIndoorviewer({ splitIndoorViewer: !this.splitIndoorViewer })
    }
  }
}
</script>

<style scoped lang="scss">
@use '@/styles/variables.scss' as old-variables;

.split-view-buttons {
  bottom: calc(#{old-variables.$margin-small + old-variables.$margin-small} + 10px);
  display: flex;
  flex-direction: row;
  justify-content: center;
  left: calc((#{old-variables.$width-indoorviewer} * 0.5) - 51px);
  position: absolute;
  &--active {
    left: calc((#{old-variables.$width-indoorviewer} * 0.5) - 74px);
  }
}
@media screen and (max-width: 1024px) {
  .split-view-buttons {
    display: none;
  }
}

@media screen and (max-width: 658px) {
  .split-view-buttons {
    display: none;
  }
}
</style>
